import { Service } from "@shared/types";

import { mapByField } from '@client-shared/lib/map';
import { ServicesActions, ServicesState, SetLoadingAction, SetServicesAction } from './types';

export const initialState: ServicesState = {
  loading: true,
  services: new Map(),
};

export function setLoading(loading: boolean): SetLoadingAction {
  return {
    type: "SET_LOADING",
    payload: { loading },
  };
}

export function setServices(services: Service[]): SetServicesAction {
  return {
    type: "SET_SERVICES",
    payload: { services },
  };
}

export function reducer(state: ServicesState, action: ServicesActions): ServicesState {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload.loading };
    case "SET_SERVICES":
      return { ...state, services: mapByField("id", action.payload.services) };
    default:
      return state;
  }
}
